export default function (data) {
    return fetch(`https://gitlab.com/api/v4/groups?top_level_only=true`, {
        method: 'GET',
        headers: new Headers({
            'Authorization': `Bearer ${data.token}`,
            'Content-Type': 'application/json'
        })
    }).then(response => response.json()).then(data => data)
}
